import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'attribute_options',
            name: 'attributeOption',
            class: 'Modules\\Site\\Entities\\AttributeOption'
        }
    }
}